import { defineComponent as S, ref as h, computed as s, openBlock as o, createElementBlock as r, normalizeClass as a, createCommentVNode as p, createElementVNode as c, toDisplayString as y, renderSlot as C } from "vue";
import { _ as E } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var e = /* @__PURE__ */ ((t) => (t.L = "l", t.M = "m", t))(e || {});
const z = [
  // Layout
  "grow",
  "flex",
  "flex-col",
  "justify-center",
  "items-center",
  // Box
  "w-full",
  // Spacing
  "gap-sm"
], k = [
  // Spacing
  "mb-sm"
], v = {
  [e.L]: [
    // Box
    "h-3xl"
  ],
  [e.M]: [
    // Box
    "h-2xl"
  ]
}, x = [
  // Theme
  "theme-foreground-default",
  "dark:theme-foreground-default-dark"
], $ = {
  [e.L]: [
    // Typography
    "typography-headline-2"
  ],
  [e.M]: [
    // Typography
    "typography-headline-4"
  ]
}, g = [
  "text-center",
  // Theme
  "text-outline",
  "dark:text-outline-dark"
], M = g, u = {
  [e.L]: [
    // Typography
    "typography-body-2-regular"
  ],
  [e.M]: [
    // Typography
    "typography-caption-regular"
  ]
}, L = u, _ = S({
  name: "OrEmptyState",
  props: {
    /**
     * Size of the component, affects font and icon size.
     * Use Large if the component takes all screen space,
     * and Medium if it is a part of the complex layout.
     */
    size: {
      type: String,
      default: () => e.M
    },
    /**
     * The heading of the empty state block.
     */
    heading: {
      type: String,
      default: ""
    },
    /**
     * Additional text such as a hint for a user with proposed next steps.
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * Path to the image to display above the heading.
     * Image height is fixed depending on `size` prop, width is undefined to preserve aspect ratio.
     */
    imageSrc: {
      type: String,
      default: void 0
    }
  },
  setup(t) {
    const n = h(), l = s(() => [
      "or-empty-state-v3",
      ...z
    ]), i = s(() => [
      "or-empty-state_image",
      ...k,
      ...v[t.size]
    ]), m = s(() => [
      "or-empty-state_heading",
      ...x,
      ...$[t.size]
    ]), d = s(() => [
      "or-empty-state_text",
      ...g,
      ...u[t.size]
    ]), f = s(() => [
      "or-empty-state_content",
      ...M,
      ...L[t.size]
    ]);
    return {
      root: n,
      rootClasses: l,
      imageClasses: i,
      headingClasses: m,
      textClasses: d,
      slotClasses: f
    };
  }
}), O = ["src"];
function b(t, n, l, i, m, d) {
  return o(), r("div", {
    ref: "root",
    class: a(t.rootClasses)
  }, [
    t.imageSrc ? (o(), r("img", {
      key: 0,
      src: t.imageSrc,
      class: a(t.imageClasses),
      alt: ""
    }, null, 10, O)) : p("", !0),
    c("div", {
      class: a(t.headingClasses)
    }, y(t.heading), 3),
    t.$slots.default ? (o(), r("div", {
      key: 1,
      class: a(t.slotClasses)
    }, [
      C(t.$slots, "default")
    ], 2)) : p("", !0),
    c("div", {
      class: a(t.textClasses)
    }, y(t.text), 3)
  ], 2);
}
const H = /* @__PURE__ */ E(_, [["render", b]]);
export {
  e as E,
  H as O
};
//# sourceMappingURL=OrEmptyState-C6viT2WQ.mjs.map
